import React, { useState, useEffect, useRef } from "react";
import { injectModels } from "../../redux/injectModels";
import {
  PaymentService,
  AuthService,
  EventApplicationRetailService,
  EventApplicationService,
  OpensignService,
  EventService,
} from "../../services";
import axios from "axios";
import { toast } from "react-toastify";
import { PaymentStatus, ApplicationStatus } from "../../constants/Enum";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import { getBusinessProfileById } from "../../services/BusinessProfileService";
import { globalConstant } from "../../constants/globalConstant";
import { GlobalSettingService } from "../../services";

import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../utils/common-methods";
import Swal from "sweetalert2";
const html2pdf = require("html2pdf.js");

const PaymentCard = (props) => {
  const loginUser = AuthService.getLoginUser();
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();
  const [formValue, setFormvalues] = useState();
  //const [openApiResponse, setOpenApiResponse] = useState("");
  // const EventId = EventService.getSelectedEvent();
  //const [openApiEmail, setOpenApiEmail] = useState("");

  const [isChecked, setIsChecked] = useState(false);
  const [showError, setShowError] = useState(false);
  const [vatPercent, setVatPercent] = useState(0);
  const [openSignDetails, setOpenSignDetails] = useState("");

    const contentRef = useRef();

  // const [filteredData, setFilteredData] = useState([]);
  // const { appId } = useParams();

  const handlePaymentIntent = async () => {
    try {
      props.application.setLoading(true);
      if (
        props &&
        props.paymentDetails &&
        props.paymentDetails.isFinalPayment
      ) {
        // handleFinalPayment
        await handleFinalPayment();
      } else {
        //handlePartPayment();
        await handlePartPayment();

        // await createDocs();
      }
      props.application.setLoading(false);
    } catch (error) {
      const message = handleConsoleError(error);
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };

  const handleFinalPayment = async () => {
    try {
      const remainingAmount = props?.paymentDetails?.remainingAmount || 0;
      const reqData = {
        amount: Number(formatAmount(remainingAmount)),
        connectedAccountId: props?.paymentDetails?.connectedAccountId,
        isFinalPayment: true,
      };
      const res = await PaymentService.createPaymentIntent(reqData);
      if (res?.isSuccess) {
        if (res?.data) {
          const clientSecret = res?.data?.clientSecret;
          // Confirm the payment with the Stripe API
          const { error, paymentIntent } = await stripe.confirmCardPayment(
            clientSecret,
            {
              payment_method: {
                card: elements.getElement(CardElement),
              },
            },
          );
          if (paymentIntent) {
            //save payment details
            const paymentIntentDetails = {
              usersId: props?.paymentDetails?.traderId,
              request: JSON.stringify(reqData),
              response: JSON.stringify(paymentIntent),
              connectedAccount: props?.paymentDetails?.connectedAccountId,
              applicationId: props?.paymentDetails?.appId,
              amount: Number(formatAmount(remainingAmount)),
              status: PaymentStatus.Paid,
              paymentIntentId: paymentIntent?.id,
              partPaymentNo: 2,
            };

            await savePaymentDetails(paymentIntentDetails);
            toast.success("Payment completed successfully");

            navigate(routes.ACCOUNT_APPLICATIONS);
          } else {
            toast.error("Payment declined", error);
          }
        } else {
          //setSeletedPlan("no plan");
        }
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };

  // ********  Create Document ****************
  const createDocs = async () => {
    //upload doc   for Retails
    if (!props?.paymentDetails?.IsCaterer) {
      try {
        let id = props?.paymentDetails?.appId;
        // Step 1: Fetch `litterData`
        const litterRes = await EventApplicationRetailService.getRetailApplicationPaymentById(
          id,
        );
        let litterData = [];
        if (litterRes?.isSuccess && litterRes?.data?.length > 0) {
          litterData = litterRes?.data;
        }
        // Step 2: Fetch `application` and other related data

        let applicationData = {};
        let unitData = {};
        let documentsData = [];
        let traderId = null;

        const appRes = await EventApplicationRetailService.getRetailApplicationById(
          id,
        );
        if (appRes?.isSuccess) {
          applicationData = appRes?.data;
          unitData = appRes?.data?.objEventApplicationCateresDetailsViewModel;
          documentsData = appRes?.data?.objEventAppCatersDocModel;
          traderId = appRes?.data?.traderId;
        }

        // Step 3: Fetch `businessData` using traderId
        let businessData = {};
        if (traderId) {
          const userId = traderId;
          const businessRes = await getBusinessProfileById(userId);
          if (businessRes?.isSuccess) {
            businessData = businessRes?.data;
            businessData.video = "";
          }
        }

        //EO LOGO
        let eventLogoURL = "";
        //let businessDataEO = {};
        const eventData = await EventService.getEventLogoById(
          applicationData?.eventId,
        );
        if (eventData?.isSuccess) {
          eventLogoURL = eventData?.data?.logoImage;
        }

        const updatedFormValues = {
          ...formValue,
          litterData,
          applicationData,
          unitData,
          documentsData,
          businessData,
          eventLogoURL,
        };

        setFormvalues(updatedFormValues);

        // Retails PDF Generater
        const { pdfBase64, totalPages } = await ReatiilsSignPDF(
          updatedFormValues,
        );

        await sendToOpenAPI(
          pdfBase64,
          totalPages,
          businessData?.email,
          businessData?.contactlegalname,
          "Retail Trade Stands Contract",
        ).then(async (x) => {
          const requestData = {
            applicationId: appRes?.data?.id,
            applicationType: "R",
            documentId: x?.objectId,
            status: "sent",
            userId: appRes?.data?.traderId,
          };
          OpensignService.addOpenSign(requestData)
            .then((y) => {
              toast.success(y?.message);
            })
            .catch((erro) => {
              toast.error(erro?.message);
            });
        });
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
      }
    } else {
      try {
        // ********** For Caters Contact*******
        let appId = props?.paymentDetails?.appId;
        // Step 1: Fetch `litterData`
        const litterRes = await EventApplicationService.getCaterApplicationPaymentById(
          appId,
        );
        let litterData = [];
        if (litterRes?.isSuccess && litterRes?.data?.length > 0) {
          litterData = litterRes?.data;
        }

        // Step 2: Fetch `application` and other related data
        let applicationData = {};
        let unitData = {};
        let documentsData = [];
        let traderId = null;

        const appRes = await EventApplicationService.getCaterApplicationById(
          appId,
        );
        if (appRes?.isSuccess) {
          applicationData = appRes?.data;
          unitData = appRes?.data?.objEventApplicationCateresDetailsViewModel;
          documentsData = appRes?.data?.objEventAppCatersDocModel;
          traderId = appRes?.data?.traderId;
        }

        // Step 3: Fetch `businessData` using traderId
        let businessData = {};
        if (traderId) {
          const userId = traderId;
          const businessRes = await getBusinessProfileById(userId);
          if (businessRes?.isSuccess) {
            businessData = businessRes?.data;
            // setOpenApiEmail(businessData.email);
            businessData.video = "";
          }
        }

        //EO LOGO
        // let businessDataEO = {};
        let eventLogoURL = "";
        const eventData = await EventService.getEventLogoById(
          applicationData?.eventId,
        );
        if (eventData?.isSuccess) {
          eventLogoURL = eventData?.data?.logoImage;
        }
        const updatedFormValues = {
          ...formValue,
          litterData,
          applicationData,
          unitData,
          documentsData,
          businessData,
          eventLogoURL,
        };

        setFormvalues(updatedFormValues);
        // Caters PDF Generate
        const { pdfBase64, totalPages } = await CatersSignPdf(
          updatedFormValues,
        );

        await sendToOpenAPI(
          pdfBase64,
          totalPages,
          businessData?.email,
          businessData?.contactlegalname,
          "Caterer Contract",
        ).then(async (x) => {
          const requestData = {
            applicationId: appRes?.data?.id,
            applicationType: "C",
            documentId: x?.objectId,
            status: "sent",
            userId: loginUser?.id,
          };
          OpensignService.addOpenSign(requestData)
            .then((y) => {
              toast.success(y?.message);
            })
            .catch((erro) => {
              toast.error(erro?.message);
            });
        });
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
      }
    }
  };

  const handlePartPayment = async () => {
    try {
      const buyerFee = props?.paymentDetails?.buyerFee || 0;
      //const processingFee = props?.paymentDetails?.processingFee || 0;
      const applicationFee = props?.paymentDetails?.applicationFee || 0;
      const amountTotal = props?.paymentDetails?.amount || 0;

      const reqData = {
        amount: Number(formatAmount(amountTotal - (applicationFee + buyerFee))),
        connectedAccountId: props?.paymentDetails?.connectedAccountId,
        applicationFeeAmount: Number(formatAmount(applicationFee + buyerFee)), //( admin Fees + buyer fees + processing fees)
        isFinalPayment: props?.paymentDetails?.initial,
      };
      const res = await PaymentService.createPaymentIntent(reqData);
      if (res?.isSuccess) {
        if (res?.data) {
          const clientSecret = res?.data?.clientSecret;
          // Confirm the payment with the Stripe API
          const { error, paymentIntent } = await stripe.confirmCardPayment(
            clientSecret,
            {
              payment_method: {
                card: elements.getElement(CardElement),
              },
            },
          );
          if (paymentIntent) {
            //save payment details
            const paymentIntentDetails = {
              usersId: props?.paymentDetails?.traderId,
              request: JSON.stringify(reqData),
              response: JSON.stringify(paymentIntent),
              connectedAccount: props?.paymentDetails?.connectedAccountId,
              applicationId: props?.paymentDetails?.appId,
              amount: Number(
                formatAmount(amountTotal - (applicationFee + buyerFee)),
              ),
              applicationFee: Number(formatAmount(applicationFee + buyerFee)),
              remainingAmount: props?.paymentDetails?.remainingAmount,
              status: props?.paymentDetails?.initial
                ? PaymentStatus.Paid
                : PaymentStatus.Unpaid,
              paymentIntentId: paymentIntent?.id,
              partPaymentNo: 1,
              isFinalPayment: props?.paymentDetails?.initial,
            };

            await savePaymentDetails(paymentIntentDetails);
            if (props?.paymentDetails?.IsCaterer) {
              //updateCaterStatus
              await EventApplicationService.updateCaterApplicationStatus({
                id: props?.paymentDetails?.appId,
                status: props?.paymentDetails?.initial
                  ? ApplicationStatus.Approved
                  : ApplicationStatus.Awaiting,
              });
            } else {
              //updateCaterStatus
              await EventApplicationRetailService.updateRetailApplicationStatus(
                {
                  id: props?.paymentDetails?.appId,
                  status: props?.paymentDetails?.initial
                    ? ApplicationStatus.Approved
                    : ApplicationStatus.Awaiting,
                },
              );
            }
            if (!props?.paymentDetails?.initial) {
              await createDocs();
            }

            toast.success("Payment completed successfully");
            Swal.fire({
              title: "Contract Signing",
              text: "Please check your email and sign the contract",
              icon: "info",
              buttonsStyling: false,
            });
            navigate(routes.ACCOUNT_APPLICATIONS);
          } else {
            toast.error("Payment declined", error);
          }
          //save logs to database
        } else {
          //setSeletedPlan("no plan");
        }
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      props.application.setLoading(false);
      toast.error(error?.message || message);
    }
  };

  //Reatils  Document Signature PDF
  const ReatiilsSignPDF = async (formValue) => {
    try {
      let html = globalConstant.ReatiilsSignPDFHTML;
      const replacements = {};
      replacements["@businessLogoUrl@"] = formValue?.eventLogoURL || "";
      // Add other values to the map for repeated use
      replacements["@businessName@"] =
        formValue?.businessData?.businessName || "";
      replacements["@contactlegalname@"] =
        formValue?.businessData?.contactlegalname || "";
      replacements["@contactlegalname@"] =
        formValue.businessData.contactlegalname || "";
      replacements["@address@"] = formValue?.businessData?.address || "";
      replacements["@city@"] = formValue?.businessData?.city || "";
      replacements["@zipCode@"] = formValue?.businessData?.zipCode || "";
      replacements["@email@"] = formValue?.businessData?.email || "";
      replacements["@phone@"] = formValue?.businessData?.phone || "";
      replacements["@onsiteContact@"] =
        formValue?.applicationData?.onSiteContact || "";
      replacements["@onsiteTel@"] = formValue?.applicationData?.onSiteTel || "";

      replacements["@trestletablePrice@"] =
        formValue?.applicationData?.trestletablePrice || "";
      replacements["@trestletable@"] =
        formValue?.applicationData?.trestletable === true ? "Yes" : "No";

      replacements["@bannerrailfortentsPrice@"] =
        formValue?.applicationData?.bannerrailfortentsPrice || "";
      replacements["@bannerrailfortents@"] =
        formValue?.applicationData?.bannerrailfortents === true ? "Yes" : "No";

      replacements["@additionalpassesPrice@"] =
        formValue?.applicationData?.additionalpassesPrice || "";
      replacements["@additionalpasses@"] =
        formValue?.applicationData?.additionalpasses || "";

      replacements["@twinsockets13ampPrice@"] =
        formValue?.applicationData?.twinsockets13ampPrice || "";
      replacements["@twinsockets13amp@"] =
        formValue?.applicationData?.twinsockets13amp === true ? "Yes" : "No";

      replacements["@amp16Price@"] =
        formValue?.applicationData?.amp16Price || "";
      replacements["@amp16@"] =
        formValue?.applicationData?.amp16 === true ? "Yes" : "No";

      replacements["@amp32Price@"] =
        formValue?.applicationData?.amp32Price || "";
      replacements["@amp32@"] =
        formValue?.applicationData?.amp32 === true ? "Yes" : "No";

      replacements["@name@"] = formValue?.businessData?.contactlegalname || "";
      replacements["@date@"] = formatDateENGB(new Date());

      replacements["@describesyourstand@"] =
        formValue?.applicationData?.describesyourstand || "";

      // Handle litter bond data replacement
      html = html.replace(
        /@tableHeader@/g,
        (formValue.litterData ?? [])
          .map(
            (msd) => `
                            <tr>
                                <td>${msd?.name}</td>
                                <td>£${formatAmount(msd?.amount)}</td>
                                <td>£${formatAmount(msd?.vat)}</td>
                                <td>£${formatAmount(msd?.total)}</td>
                            </tr>`,
          )
          .join(""),
      );

      // Petch data replacement
      html = html.replace(
        /@Pitch@/g,
        (
          formValue.applicationData
            .objEventApplicationRetailPitchDtlViewModel ?? []
        )
          .map(
            (msd) => `
              <tr>
                  <td>${msd?.pitchLength}m X ${msd?.pitchWidth}m  ${msd?.pitchName}</td>
                  <td> £${msd?.pitchPrice}</td>
              </tr>
              `,
          )
          .join(""),
      );

      // Now replace all placeholders in HTML
      for (let placeholder in replacements) {
        const regex = new RegExp(placeholder, "g"); // Create a global regex for each placeholder
        html = html.replace(regex, replacements[placeholder]);
      }

       contentRef.current.innerHTML =`${html}`;
        const element = contentRef.current;
             // Wait for images
     const images = element.querySelectorAll("img");
  await Promise.all(
    [...images].map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise(res => {
        img.onload = img.onerror = res;
      });
    })
  );

       // Small delay for browser rendering
      await new Promise(resolve => setTimeout(resolve, 200));
      const updatedHTML=contentRef.current.innerHTML;

      // PDF generation options
      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `Reatils.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 150,
          scale: 2,
          letterRendering: true,
          useCORS: true,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
        },
      };
      const pdf = await html2pdf()
        .set(opt)
        .from(updatedHTML)
        .toPdf()
        .get("pdf");

      const totalPages = pdf.internal.getNumberOfPages(); // Total page count


      let pdfBase64 = await pdf.output("datauristring");

      if (pdfBase64.includes(",")) {
      pdfBase64 = pdfBase64.split(",")[1];
    }

      return { pdfBase64, totalPages };
    } catch (error) {
      console.log("Error", error);
    }
  };

  // Catres Document Signature PDF
  const CatersSignPdf = async (formValue) => {
    try {
      const isVatApply = formValue.applicationData.vat > 0;
      let html = globalConstant.CatersSignPdfHTML;
      const replacements = {};

      replacements["@businessLogoUrl@"] = formValue?.eventLogoURL || "";
      // Add other values to the map for repeated use
      replacements["@componyName@"] =
        formValue?.businessData?.businessName || "";
      replacements["@contactName@"] =
        formValue?.businessData?.contactlegalname || "";
      replacements["@address@"] = formValue?.businessData?.address || "";
      replacements["@emailAddress@"] = formValue?.businessData?.email || "";
      replacements["@phone@"] = formValue?.businessData?.phone || "";
      replacements["@onsiteContact@"] =
        formValue?.applicationData?.onSiteContact || "";
      replacements["@onsiteTel@"] = formValue?.applicationData?.onSiteTel || "";
      replacements["@expectedArrivalDate@"] =
        formValue?.applicationData?.expectedArrivalDate || "";
      replacements["@expectedArrivalTimeStr@"] =
        formValue?.applicationData?.expectedArrivalTimeStr || "";
      replacements["@busniessName@"] =
        formValue?.businessData?.businessName || "";
      replacements["@busniessName(Data)@"] =
        formValue?.businessData?.businessName || "";

      replacements["@staffBuildWristband@"] =
        formValue?.applicationData?.staffBuildWristband || "";
      replacements["@siteVehiclePass@"] =
        formValue?.applicationData?.siteVehiclePass || "";
      replacements["@serviceVehiclePass@"] =
        formValue?.applicationData?.serviceVehiclePass || "";
      replacements["@mceWristband@"] =
        formValue?.applicationData?.mceWristband || "";

      replacements["@name@"] = formValue?.businessData?.contactlegalname || "";
      replacements["@date@"] = formatDateENGB(new Date());

      // Now replace all placeholders in HTML
      for (let placeholder in replacements) {
        const regex = new RegExp(placeholder, "g"); // Create a global regex for each placeholder
        html = html.replace(regex, replacements[placeholder]);
      }

      html = html.replace(
        /@Dimesion@/g,
        (formValue.unitData ?? [])
          .map(
            (msd) => `
                      <tr>
                          <td>${msd?.unitLength || "-"}</td>
                          <td>${msd?.unitWidth || "-"}</td>
                          <td>${msd?.bohLength || "-"}</td>
                          <td>${msd?.bohWidth || "-"}</td>
                      </tr>`,
          )
          .join(""),
      );
      html = html.replace(/@vat@/g, vatPercent);

      //Stage1 unit phase
      html = html.replace(
        /@units@/g,
        (() => {
          const units = formValue?.unitData ?? [];
          const totalUnits = units.length;
          const unitFee = units[0]?.amount || 0;
          const vat = isVatApply ? (unitFee * vatPercent) / 100 : 0; // 20% VAT
          const total = unitFee + vat;
          const concessionFee = formatAmount(units[0]?.concessionFee) || "-";
          return `
        <tr>
          <td>${totalUnits}</td>  <!-- Shows total number of units -->
          <td>£${formatAmount(unitFee)}</td>  
          <td>£${formatAmount(vat)}</td>  
          <td>£${formatAmount(total)}</td>  
          <td>£${concessionFee}</td>  
        </tr>`;
        })(),
      );

      // Backup vehicles
      html = html.replace(
        /@backupVehicles@/g,
        (() => {
          const units = formValue?.unitData ?? [];
          const hasBackupVehicle = units.some((unit) => unit?.backUPVehicle);

          const backupTable = hasBackupVehicle
            ? `<table>
       <tr> 
         <td style="text-align: left;border: none;" colspan="4">
          <h4 style="font-weight: 500; text-align: left;">Back Up Vehicles</h4>
        </td>
       </tr>
        </table>
        <table>
          <tr>
            <th>UNIT</th>
            <th>BACKUP VEHICLE TYPE</th>
            <th>CONNECTION 1X16 SINGLE QTY</th>
            <th>CONNECTION 1X32 SINGLE QTY</th>
          </tr>
          ${units
            .filter((unit) => unit?.backUPVehicle)
            .map((unit, index) => {
              return `
                <tr>
                  <td> ${index + 1}</td>
                  <td>${unit?.backUPVehicleType || "-"}</td>
                  <td>${unit?.bvConn1x16SingleQty || 0}</td>
                  <td>${unit?.bvConn1x32SingleQty || 0}</td>
                </tr>`;
            })
            .join("")}
        </table>
        <br/>`
            : "";

          return `
    
      ${hasBackupVehicle ? `${backupTable}` : ""}
   `;
        })(),
      );

      // ******* Power Requirment *********
      let totalConnections = {
        "1X16 SINGLE": { netCost: 0, qty: 0, totalCost: 0 },
        "1X32 SINGLE": { netCost: 0, qty: 0, totalCost: 0 },
      };

      (formValue.unitData ?? []).forEach((unit) => {
        const connectionData = [
          {
            name: "1X16 SINGLE",
            netCost: unit?.cost1x16Single || 0,
            qty:
              (unit?.conn1x16SingleQty || 0) +
              (unit?.bohConn1x16SingleQty || 0) +
              (unit?.bvConn1x16SingleQty || 0),
          },
          {
            name: "1X32 SINGLE",
            netCost: unit?.cost1x32Single || 0,
            qty:
              (unit?.conn1x32SingleQty || 0) +
              (unit?.bohConn1x32SingleQty || 0) +
              (unit?.bvConn1x32SingleQty || 0),
          },
        ];

        connectionData.forEach((conn) => {
          const vat = isVatApply ? (conn?.netCost * vatPercent) / 100 : 0; // VAT @ 20%
          const total = (conn?.netCost + vat) * conn?.qty;

          if (totalConnections[conn.name].netCost === 0) {
            totalConnections[conn.name].netCost = conn?.netCost;
          }

          totalConnections[conn.name].qty += conn?.qty;
          totalConnections[conn.name].totalCost += total;
        });
      });

      html = html.replace(
        /@connections@/g,
        `
    <table border="1" cellspacing="0" cellpadding="5">
      <tr>
        <th>CONNECTION</th>
        <th>NET COST</th>
        <th>VAT @ ${vatPercent}%</th>
        <th>TOTAL QTY</th>
        <th>TOTAL COST</th>
      </tr>
      ${Object.entries(totalConnections)
        .map(([name, data]) => {
          const vat = isVatApply
            ? formatAmount((data?.netCost * vatPercent) / 100)
            : 0; // VAT for a single unit
          return `
            <tr>
              <td>${name}</td>
              <td>£${data.netCost.toFixed(
                2,
              )}</td>  <!-- Keep original NET COST -->
              <td>£${vat}</td>  <!-- VAT per unit -->
              <td>${data?.qty}</td>  <!-- Total quantity across units -->
              <td>£${formatAmount(
                data?.totalCost,
              )}</td>  <!-- Total cost across units -->
            </tr>
          `;
        })
        .join("")}
    </table>
  `,
      );

      // Handle litter bond data replacement
      html = html.replace(
        /@tableHeader@/g,
        (formValue.litterData ?? [])
          .map(
            (msd) => `
                      <tr>
                          <td>${msd?.name}</td>
                          <td>£${formatAmount(msd?.amount)}</td>
                          <td>£${formatAmount(msd?.vat)}</td>
                          <td>£${formatAmount(msd?.total)}</td>
                      </tr>`,
          )
          .join(""),
      );

      // Handle documents data replacement
      html = html.replace(
        /@document@/g,
        (() => {
          const uniqueDocuments = [];
          const seenTitles = new Set();

          // Filter out duplicate docTitle entries
          (formValue.documentsData ?? []).forEach((msd) => {
            if (!seenTitles.has(msd?.docTitle)) {
              seenTitles.add(msd?.docTitle);
              uniqueDocuments.push(msd);
            }
          });

          return `
            <table>
              <tr>
                <th>Details</th>
                <th>Please Complete Specific Details</th>
              </tr>
              ${uniqueDocuments
                .map((msd) => {
                  let docDetails = "";
                  docDetails = msd.isFile ? msd?.documentType : msd?.docTitle;
                  return `
                    <tr>
                      <td>${docDetails}</td>
                      <td>${msd?.docPath || "-"}</td>
                    </tr>`;
                })
                .join("")}
            </table>`;
        })(),
      );
       contentRef.current.innerHTML =`${html}`;
        const element = contentRef.current;
             // Wait for images
     const images = element.querySelectorAll("img");
  await Promise.all(
    [...images].map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise(res => {
        img.onload = img.onerror = res;
      });
    })
  );

       // Small delay for browser rendering
      await new Promise(resolve => setTimeout(resolve, 200));
      const updatedHTML=contentRef.current.innerHTML;
      // PDF generation options
      const opt = {
        margin: [20, 20, 20, 20],
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        filename: `Caterers.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 150,
          scale: 2,
          letterRendering: true,
          useCORS: true,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "portrait",
          putTotalPages: true,
        },
      };
      const pdf = await html2pdf()
        .set(opt)
        .from(updatedHTML)
        .toPdf()
        .get("pdf");

      const totalPages = pdf.internal.getNumberOfPages(); // Total page count

      let pdfBase64 = await pdf.output("datauristring");
       if (pdfBase64.includes(",")) {
      pdfBase64 = pdfBase64.split(",")[1];
    }

      return { pdfBase64, totalPages };
    } catch (error) {
      console.log("Error", error);
    }
  };

  //******** Open sign document ***********
  const sendToOpenAPI = async (
    pdfBase64,
    totalPages,
    openApiEmail,
    userName,
    docName,
  ) => {
    if (!pdfBase64) {
      handleConsoleError("No PDF generated. Please generate the PDF first.");
      return;
    }
    const body = {
      file: pdfBase64, // Send the base64 PDF
      title: docName + " Document",
      description: docName + " Description",
      note: docName + " Note",
      timeToCompleteDays: 15,
      signer: {
        role: "Trader",
        email: openApiEmail,
        name: userName,
        phone: "",
        widgets: [
          {
            type: "signature",
            page: totalPages,
            x: 455,
            y: 270,
            w: 38,
            h: 46,
          },
        ],
      },
      folderId: "",
      send_email: true,
      email_subject: "",
      email_body: "",
      enableTour: false,
    };
    try {
      const openSignURL = process.env.REACT_APP_OPENSIGN_URL;
      const openSignAPIToekn = openSignDetails;
      const response = await axios.post(openSignURL, body, {
        headers: {
          "Content-Type": "application/json",
          "x-api-token": openSignAPIToekn,
        },
      });
      // const objectID = response?.data.objectId;
      return response?.data;
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const savePaymentDetails = async (paymentIntentDetails) => {
    try {
      props.application.setLoading(true);
      await PaymentService.savePaymentDetails(paymentIntentDetails);
    } catch (error) {
      props.application.setLoading(false);
      //toast.error("Something went wrong");
    }
  };

  const handleCardError = (event) => {
    setIsValid(event?.complete ?? false);
    if (event?.complete) {
      setError("");
      // enable save button
    } else if (event?.error) {
      setError(event?.error?.message);
    }
  };

  const getGlobalValues = async () => {
    try {
      const res = await GlobalSettingService.getGlobalSettingList();
      if (res?.isSuccess && res?.data?.length > 0) {
        const vat = res?.data?.find(
          (item) => item?.keyName?.trim() === globalConstant.VAT_PERCENT.trim(),
        );
        if (vat) {
          const vatInt = vat?.keyValue;
          setVatPercent(vatInt);
        }
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const getOpenSignDetails = async () => {
    try {
      const res = await GlobalSettingService.getOpenSignDetails();
      if (res?.isSuccess && res?.data) {
        setOpenSignDetails(GlobalSettingService.decrypt(res?.data?.keyValue));
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };
  useEffect(() => {
    const fetchDetails = async () => {
      await getOpenSignDetails();
    };
    fetchDetails();
  }, [openSignDetails]);

  useEffect(() => {
    const init = async () => {
      try {
        await getGlobalValues();

        if (!props?.paymentDetails?.connectedAccountId) {
          setError("Connected account not found");
        } else {
          setError(null); // clear error if account exists
        }
      } catch (err) {
       const message= handleConsoleError(err);
        toast.error(err?.message|| message);
        setError("Failed to initialize payment settings");
      }
    };

    init();
  }, [props.paymentDetails]);

  // ******* For error ******
  const handlePaymentClick = () => {
    if (!isChecked) {
      setShowError(true);
    } else {
      setShowError(false);
      handlePaymentIntent();
    }
  };

  return (
    <React.Fragment>
      <section className="loginswallow">
        {/* <h3>{props?.paymentDetails?.title}</h3> */}
        <div className="form-container">
          <div className="row mb-3">
            <div className="col-sm-12">
              <h4 style={{ fontSize: "24px", fontWeight: "600" }}>
                Payment details summary
              </h4>
            </div>
          </div>
          {props &&
            props.paymentDetails &&
            props.paymentDetails.isFinalPayment && (
              <React.Fragment>
                <div className="row mb-3">
                  <div className="col-sm-6">
                    <span style={{ fontSize: "18px", fontWeight: "600" }}>
                      Amount:
                    </span>
                  </div>
                  <div className="col-sm-6">
                    <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                      £ {formatAmount(props?.paymentDetails?.remainingAmount)}
                    </strong>
                  </div>
                </div>
              </React.Fragment>
            )}
          {props &&
            props.paymentDetails &&
            !props.paymentDetails.isFinalPayment && (
              <React.Fragment>
                <div className="row mb-3">
                  <div className="col-sm-6">
                    {props?.paymentDetails?.initialPaymentPer && (
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>
                        Amount ({props?.paymentDetails?.initialPaymentPer}
                        %)
                      </span>
                    )}
                    {!props?.paymentDetails?.initialPaymentPer && (
                      <span style={{ fontSize: "18px", fontWeight: "600" }}>
                        Amount :
                      </span>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <strong style={{ fontSize: "18px", fontWeight: "600" }}>
                      £ {formatAmount(props?.paymentDetails?.amount)}
                    </strong>
                  </div>
                </div>
              </React.Fragment>
            )}
          <div className="row mb-3">
            <div className="col-sm-12">
              <span style={{ fontSize: "14px", fontWeight: "600" }}>
                Please enter your card details in order to complete your
                purchase.
              </span>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-12">
              <CardElement className="mb-3" onChange={handleCardError} />

              {error && <div style={{ color: "red" }}>{error}</div>}
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12">
              <div className="d-flex align-center" style={{ gap: "10px" }}>
                <label
                  style={{ margin: "0px", fontSize: "12px", fontWeight: "600" }}
                >
                  Funds may be held for up to 7 days
                </label>
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-12">
              <div
                className="d-flex align-center"
                style={{ gap: "10px", flexDirection: "column" }}
              >
                <div className="d-flex align-center" style={{ gap: "10px" }}>
                  <input
                    type="radio"
                    style={{ width: "19px", padding: "0px", height: "19px" }}
                    checked={isChecked}
                    onChange={() => {
                      setIsChecked(!isChecked);
                      setShowError(false);
                    }}
                  />
                  I accept the
                  <a
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "14px",
                      margin: "0px",
                      fontWeight: "600",
                    }}
                    href={routes.MANAGE_PAYMENT_TERMS}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Payment Terms
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div
                className="d-flex align-items-center justify-content-center flex-column"
                style={{ gap: "10px" }}
              >
                <h4>We accept the following cards</h4>
                <img
                  width={"180"}
                  src="/assets/images/6220ac0f912013c51947f9c4.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-12">
              <button
                type="button"
                style={{ backgroundColor: isValid ? "#ed307c" : "#adb5bd" }}
                disabled={!isValid}
                onClick={handlePaymentClick}
              >
                Pay
              </button>
              {showError && (
                <p style={{ color: "red", marginTop: "5px" }}>
                  Please accept the terms to proceed!
                </p>
              )}
            </div>
          </div>

          <div className="row ">
            <div className="col-sm-12">
              <div
                className="d-flex align-center justify-content-center"
                style={{ gap: "10px" }}
              >
                <img src="/assets/images/secure-logos.png" alt=""></img>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-sm-12">
              <div
                className="d-flex align-center justify-content-center"
                style={{ gap: "10px" }}
              >
                <p>
                  {" "}
                  Our application is hosted on Microsoft data centres, which are
                  ISO/IEC 27001, 27017, and 27018 certified.
                </p>
              </div>
            </div>
          </div>
        </div>
          <div ref={contentRef}  style={{display:"none"}}
            
>  
    </div>
      </section>
    </React.Fragment>
  );
};
export default injectModels(["auth", "application"])(PaymentCard);
